"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSpecialOpcodeTemplates = getSpecialOpcodeTemplates;
function getSpecialOpcodeTemplates() {
    return `
                        // Special Operations
                        case opMap[160]: { // THIS
                            stack.push(_this);
                            pc++;
                            break;
                        }

                        case opMap[161]: { // ARGUMENTS
                            // Create arguments-like array with callee property
                            let argsArr = Array.prototype.slice.call(args || []);
                            argsArr.callee = currentFunc;
                            stack.push(argsArr);
                            pc++;
                            break;
                        }

                        case opMap[164]: { // NEW_TARGET
                            // Push new.target value (will be undefined if not called with 'new')
                            stack.push(newTarget);
                            pc++;
                            break;
                        }

                        case opMap[162]: { // NEW_REGEX
                            let regexData = constants[arg];
                            let parts = regexData.split('|||');
                            let pattern = parts[0];
                            let flags = parts[1];
                            stack.push(new RegExp(pattern, flags));
                            pc++;
                            break;
                        }

                        case opMap[163]: { // VOID
                            stack.pop();
                            stack.push(undefined);
                            pc++;
                            break;
                        }

                        case opMap[167]: { // SYMBOL
                            // Create unique symbol: Symbol(description)
                            // arg is -1 for no description, otherwise index in constants
                            if (arg === -1) {
                                stack.push(Symbol());
                            } else {
                                let desc = stack.pop();
                                stack.push(Symbol(desc));
                            }
                            pc++;
                            break;
                        }

                        case opMap[168]: { // SYMBOL_FOR
                            // Get/create global symbol: Symbol.for(key)
                            // arg is index of key in constants
                            let symbolKey = constants[arg];
                            stack.push(Symbol.for(symbolKey));
                            pc++;
                            break;
                        }

                        case opMap[169]: { // SYMBOL_KEY_FOR
                            // Get key for global symbol: Symbol.keyFor(symbol)
                            // Stack: [symbol] -> [key or undefined]
                            let sym = stack.pop();
                            stack.push(Symbol.keyFor(sym));
                            pc++;
                            break;
                        }

                        // Assignment Operators
                        case opMap[170]: { // ASSIGN
                            // Value is already on stack from assignment expression
                            pc++;
                            break;
                        }

                        // Debug/Utility
                        case opMap[200]: { // DEBUGGER
                            debugger;
                            pc++;
                            break;
                        }

                        case opMap[201]: { // NOP
                            pc++;
                            break;
                        }

                        case opMap[202]: { // END
                            return stack.length > 0 ? stack.pop() : undefined;
                        }
    `;
}
